import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
    header: {
        background: "#E8E8E8",
        display: "flex",
        alignItems: "center",
        height: "49px",
        padding: "0px 0px 0 15px",
        "& h1": {
            padding: "0px 15px",
            fontSize: "22px",
            fontWeight: 600,
            lineHeight: "28.8px",
            color: "#2D4D95",
        },
    },
    gridHeader: {
        padding: "6px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        "& .HeaderDialog": {
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
        },
    },
    gridActions: {
        textAlign: "right",
    },
    GridHeading: {
        color: "var(--accent-colors-ui-1-default, #3C4549)",
        fontFamily: "Lato",
        fontSize: "19.819px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
    },

    changeBtn: {
        fontSize: "14px",
        fontWeight: 500,
        cursor: "pointer",
        backgroundColor: "#454545",
        borderRadius: "6px",
        marginRight: "5px",
        padding: "8px 16px",
        textTransform: "capitalize",
        cursor: "pointer",
        color: "#ffffff !important",
        boxShadow:
            "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
        "&:hover": {
            color: "#ffffff",
            background: "#5e5e5e",
        },
    },

    changeBtnPosition: {
        position: 'absolute',
        bottom: '20px',
        // left: '30%',
        fontSize: "14px",
        fontWeight: 500,
        cursor: "pointer",
        backgroundColor: "#454545",
        borderRadius: "6px",
        marginRight: "5px",
        padding: "8px 16px",
        textTransform: "capitalize",
        cursor: "pointer",
        color: "#ffffff !important",
        boxShadow:
            "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
        "&:hover": {
            color: "#ffffff",
            background: "#5e5e5e",
        },
    },
    profileNavigationIco: {
        maxWidth: '20px',
        padding: '2px',
    },

    DocumentsHeading: {
        color: '#424242',
        fontFamily: 'Lato',
        fontSize: '21px',
        fontStyle: 'normal',
        fontWeight: '800',
        lineHeight: '16px',
        letterSpacing: '0.21px',
    },

    DocMainDiv: {
        padding: '40px 25px',
    },

    Card: {
        height: "230px",
        position: 'relative',
        widht: '248px',
        borderRadius: "10px",
        border: "1px solid #9f9f9f",
        display: "flex",
        padding: "30px",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        margin: "15px 0 0 0",
        boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.2)',
        position: 'relative',

        "& .CardMain": {
            textAlign: "center",
            display: "contents",
            overflowWrap: "anywhere",
        },
        "& .CardBanner": {
            position: "relative",
            width: '48px',
            height: '48px',
            maxHeight: '48px',
            minHeight: '48px',

        },
        "& .BannerImg": {
            borderRadius: "10px",
            height: '48px',
            maxHeight: '48px',
            minHeight: '48px',
        },
        "& img": {
            width: "100%",
            maxWidth: "100%",
            marginRight: "0",

        },
        "& .DetailLogo": {
            maxWidth: "24px",
            minWidth: "40px",
            maxHeight: "24px",
            position: "absolute",
            right: "0",
            top: "5px",
        },
        "& .CardHeading": {

            fontFamily: "Lato",
            fontSize: "16px",
            marginTop: '13px',
            fontStyle: "normal",
            fontWeight: "600",
            lineHight: "16px;",
            letterSpacing: "0.22px",
            marginBottom: "10px",
            color: '#7D7D7D',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
        },
        "& .CardBody": {
            color: '#424242',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            maxWidth: '100%',
            textAlign: "center",
            fontFamily: "Lato",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "16px",
            letterSpacing: "0.14px",
            marginBottom: "20px",
        },
        "& .CardLogo": {
            width: "137px",
            minWidth: "137px",
            height: "35.773px",
            marginBottom: "20px",
        },
    },
    profileDropper: {
        margin: '8px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        "& h4": {
            margin: 0,
            padding: '10px',
            color: '#0049A3',
            fontSize: '15px',
            lineHeight: '16px',
            fontFamily: 'Lato',
            textTransform: 'capitalize',
            '@media (max-width: 550px)': {
                display: 'none',
            },
        },
        "& :hover": {
            backgroundColor: 'none !important',
        },
        "& svg": {
            color: '#0049A3',
        }

    },
    Container: {
        padding: "12px",
    },
    profileDropper: {
        margin: '8px',
        display: 'flex',
        alignItems: 'center',
        filter: 'invert(0.7)',
        cursor: 'pointer',
        "& h4": {
            margin: 0,
            padding: '10px',
            color: '#0049A3',
            fontSize: '15px',
            lineHeight: '16px',
            fontFamily: 'Lato',
            textTransform: 'capitalize',
            '@media (max-width: 550px)': {
                display: 'none',
            },
        },
        "& :hover": {
            backgroundColor: 'none !important',
        },
        "& svg": {
            color: '#0049A3',
        }

    },
}));
